import React, { useState } from 'react';
import './styles/tokens.css';
import UnityHero from './components/UnityHero';
import UnityProductNav from './components/UnityProductNav';
import UnitySourceStory from './components/UnitySourceStory';
import UnityLessonShowcase from './components/UnityLessonShowcase';
import UnityDelivery from './components/UnityDelivery';
import UnityAdaptive from './components/UnityAdaptive';
import UnityImpact from './components/UnityImpact';
import UnityUseCases from './components/UnityUseCases';
import UnityPricing from './components/UnityPricing';
import UnityAiCredits from './components/UnityAiCredits';
import UnityFAQ from './components/UnityFAQ';
import UnityFinalCTA from './components/UnityFinalCTA';
import UnityDialogs from './components/UnityDialogs';
/** Product presentation within the shared AndUs shell; enquiries use existing channels. */
export default function UnityLanding({
  assetBase = '/assets/unity-learning',
  globalNavHeight = 0,
  vatRate = 0.15,
  onEvent,
}) {
  const [dialog, setDialog] = useState(null);
  const [cycle, setCycle] = useState('monthly');
  const event = (name, props) => {
    onEvent?.(name, props);
    if (name === 'billing_cycle_selected') setCycle(props.cycle);
  };
  const trial = (source, planId = 'create') => {
    event('unity_cta_clicked', { action: 'trial-enquiry', section: source, planId, interval: cycle });
    setDialog({ mode: 'trial', planId, billingCycle: cycle, source });
  };
  const demo = (source) => {
    event('unity_cta_clicked', { action: 'request-demo', section: source });
    setDialog({ mode: 'demo', source });
  };
  return (
    <div className="unity-marketing" style={{ '--ul-global-nav-height': `${globalNavHeight}px` }}>
      <a className="ul-skip-link" href="#create">
        Skip to product details
      </a>
      <UnityHero assetBase={assetBase} onTrial={() => trial('hero')} />
      <UnityProductNav onTrial={() => trial('product-nav')} />
      <UnitySourceStory assetBase={assetBase} onTrial={() => trial('source-story')} />
      <UnityLessonShowcase />
      <UnityDelivery assetBase={assetBase} />
      <UnityAdaptive assetBase={assetBase} />
      <UnityImpact onDemo={() => demo('report')} />
      <UnityUseCases assetBase={assetBase} onTrial={() => trial('use-cases')} />
      <UnityPricing
        onTrial={(planId) => trial('pricing', planId)}
        onDemo={() => demo('pricing')}
        vatRate={vatRate}
        onEvent={event}
      />
      <UnityAiCredits
        vatRate={vatRate}
        onTopUp={() => {
          event('unity_cta_clicked', { action: 'topup-options', section: 'ai-credits' });
          setDialog({ mode: 'topup', source: 'ai-credits' });
        }}
      />
      <UnityFAQ />
      <UnityFinalCTA
        assetBase={assetBase}
        onTrial={() => trial('final-cta')}
        onDemo={() => demo('final-cta')}
      />
      <UnityDialogs
        state={dialog}
        onClose={() => setDialog(null)}
        vatRate={vatRate}
      />
    </div>
  );
}
